module.exports = __webpack_public_path__ + "img/wr_1.76f728e5.png";